/**
 * "The user's AI quota may have changed" (Faz 10): fired after AI calls so the quota widgets reload.
 * Kept free of imports so apiInterceptors and the quota service can both use it without a cycle.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

export const onAiQuotaChange = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyAiQuotaChange = (): void => {
  listeners.forEach((listener) => listener());
};

// POSTs that use a daily AI pool: /ai/..., /ai-plans/..., /todos/ai/..., /todos/<id>/ai/...
const AI_PATH = /^\/?(ai\/|ai-plans\/|todos\/ai\/|todos\/[^/]+\/ai\/)/;

export const isAiQuotaRequest = (method?: string, url?: string): boolean =>
  (method || '').toLowerCase() === 'post' && AI_PATH.test(url || '');
